export default __webpack_public_path__ + "static/media/pix_powered_by_banco_central.803e73bc.png";